import {useEffect,useId,useRef} from 'react';

export type ErrorSummarySource='client'|'server'|'network'|'save';
export type ErrorSummaryItem=Readonly<{
  targetId:string;
  label:string;
  message:string;
}>;
export type ErrorSummaryProps=Readonly<{
  title:string;
  items:readonly ErrorSummaryItem[];
  source:ErrorSummarySource;
  focusKey:number|string;
}>;

function focusTarget(targetId:string){
  const target=document.getElementById(targetId);
  if(!target)return;
  let details=target.closest('details');
  while(details){details.open=true;details=details.parentElement?.closest('details')??null;}
  target.focus({preventScroll:true});
  target.scrollIntoView({block:'center',inline:'nearest'});
}

export function ErrorSummary({title,items,source,focusKey}:ErrorSummaryProps){
  const headingId=useId();
  const summary=useRef<HTMLElement>(null);

  useEffect(()=>{
    const target=summary.current;
    if(!items.length||!target)return;
    target.focus({preventScroll:true});
    target.scrollIntoView({block:'center',inline:'nearest'});
  },[focusKey]);

  if(!items.length)return null;
  return <section
    ref={summary}
    className="error-summary"
    data-error-source={source}
    role="region"
    aria-labelledby={headingId}
    tabIndex={-1}
  >
    <h2 id={headingId}>{title}</h2>
    <p>Review the following information. Your other entries remain in the form.</p>
    <ul>
      {items.map(item=><li key={item.targetId}>
        <a href={`#${item.targetId}`} onClick={event=>{event.preventDefault();focusTarget(item.targetId)}}>
          <strong>{item.label}:</strong> {item.message}
        </a>
      </li>)}
    </ul>
  </section>;
}
